import { httpGetObservable } from './utils';

const api = {
  consumableWarehouseList: url => httpGetObservable(url),
  consumableAvailableList: url => httpGetObservable(url),
};

export default api;
